// extracted by mini-css-extract-plugin
export default {"footerNavList":"FooterNavList_footerNavList__tZZMP"};